import styled, { css } from 'styled-components';
import { right } from '@kiwicom/orbit-components/lib/utils/rtl';

import { Flex, Box } from './Flexbox/Flex';

type ImageProps = {
  imageUrl: string;
  isGrayscale: boolean;
};

const Image = styled.div<ImageProps>`
  background-image: url(${({ imageUrl }) => imageUrl});
  min-height: 130px;
  min-width: 130px;
  max-width: 130px;
  background-repeat: no-repeat;
  background-size: cover;
  margin-${
    /* sc-custom "right" */
    right
  }: ${({ theme }) => theme.orbit.spaceMedium};
  ${({ isGrayscale }) =>
    isGrayscale &&
    css`
      filter: grayscale(100%);
    `}
`;
type Props = {
  readonly imageUrl?: string;
  readonly dataTest?: string;
  readonly children: JSX.Element;
  readonly isGrayscale?: boolean;
};

const PictureCard = ({ imageUrl, isGrayscale = false, children, dataTest }: Props): JSX.Element => {
  return (
    <Flex
      backgroundColor="paletteWhite"
      borderRadius="borderRadiusNormal"
      overflow="hidden"
      width="100%"
      height="100%"
      data-test={dataTest}
      alignItems="stretch"
      maxHeight="200px"
    >
      <Image imageUrl={imageUrl} isGrayscale={isGrayscale} />
      <Box paddingY="spaceMedium" width="100%">
        {children}
      </Box>
    </Flex>
  );
};

export default PictureCard;
